import React, { useState, useEffect, useRef } from "react";
import PopUpSelect from './PopUpSelect';
import PopUpCloseSublist from './PopUpCloseSublist';
import PopUpCsHistory from './PopUpCsHistory';
import PopUpEmpHistory from './PopUpEmpHistory';
import SelectFix from './../PopUp/SelectFix';
import { DropdownButton, MenuItem, Row, Grid, Col, Panel } from "react-bootstrap";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { genURL, gengetURLTEST, genpostURL, genpostURLTEST } from './../_getjson';
import axios from 'axios'
import Backdrop from './../Components/CustomBackdrop/Barckdrop'
import Snackbar from './../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import cheackdate from './../CustomFunction/Date/Checkdate'
import MaterialUIPickers from "./../Components/CustomDatepicker/MaterialUIPickers"
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
export function ReDate(TimeStamp) {
  var myDate = new Date(TimeStamp);
  var date = (myDate.getDate() < 10 ? '0' : '') + (myDate.getDate());
  var month = (myDate.getMonth() + 1 < 10 ? '0' : '') + (myDate.getMonth() + 1);
  var year = myDate.getFullYear() + 543;
  return date + "/" + month + "/" + year;
}
export function ReDate2(date) {
  var dateSp = date.split("/");
  var dataRe = dateSp[2] - 543 + "-" + dateSp[1] + "-" + dateSp[0];
  return dataRe
}
const rowTable = 300;

export default function PSOtherBad() {

  const SaleMan_code = useRef(null);
  const SaleMan = useRef(null);
  const DeliNumber = useRef(null);
  const Groupdata = useRef(null);

  const [BuyDate, setBuyDate] = useState("");
  const [Calendar1, setCalendar1] = useState("");
  const [CSHistory, setCSHistory] = useState("");
  const [EMPHistory, setEMPHistory] = useState("");
  const [CloseSublist, setCloseSublist] = useState("");
  const [SelectPopup, setSelectPopup] = useState("");
  const [products, setproducts] = React.useState([]);
  const [OtPopupType, setOtPopupType] = useState("");
  const [hidden, sethidden] = useState("");
  const [Doubledata, setDoubledata] = useState("");
  const [SUCCESS, setSUCCESS] = useState("");
  const [openBackdrop, setopenBackdrop] = useState(false);
  const [color, setColor] = useState("warning");
  const [icon, setIcon] = useState(ErrorIcon);
  const [messagealert, setMessagealert] = useState("");
  const [autoClose, setautoClose] = useState(3600);
  const [opensnackbar, setopensnackbar] = useState(false);

  React.useEffect(() => {
    setRow(rowTable);
    onSearch()
  }, []);
  function CalendarOnChange(data, DateUp) {
    var today = new Date(data);
    if (DateUp) {
      today.setDate(today.getDate() + DateUp);
    }
    var dd = "01"
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();
    if (mm < 10) { mm = '0' + mm }
    today = dd + '/' + mm + '/' + (yyyy + 543);
    return today;
  }
  function SelectSetData(data1, data2) {
    if (data1 === "Calendar") {
      setBuyDate(data2)
    }
    if (data1 === "Calendar1") {
      setCalendar1(data2)
    }
  }
  const setRow = (count) => {
    var data = [];
    for (var i = 0; i <= count - 1; i++) {
      data[i] = { C0: i + 1 }
    }
    setproducts(data)
  }
  /*----------------------------------------------------------Switch----------------------------------------------------------*/
  function Switch_Select(type) {
    setOtPopupType(type);
    setSelectPopup(!SelectPopup);
  }

  const onRemove = function () {
    setRow(rowTable);
  }
  const onSearch = async function () {
    await setRow(rowTable);
    setopenBackdrop(true)
    var url = "CC_SaleOrder/Search?"
    url += "DateStart=" + ReDate2(BuyDate);
    url += "&DateStop=" + ReDate2(Calendar1);
    // var url = "CSRIGHT/Rightmenu?usercode=" + localStorage.getItem('Username') 
    console.log(genURL(url))
    let data = []
    await axios.get(genURL(url), { timeout: 3600 }).then(res1 => {
      let res = res1.data
      if (res.length > 0) {
        for (var i = 0; i < res.length; i++) {
          data[i] = {
            C0: i + 1,
            T_Date: ReDate(res[i].docdate),
            T_Queue: res[i].docno,
            T_Code: res[i].arcode,
            T_Name: res[i].arname,
            T_Remark: res[i].remark,
            T_SaleMan: res[i].salename,
            T_Promise: "",
            T_Amount: res[i].billamount,
            T_Debtor: res[i].debtamount,
            T_Cheque: "",
            T_Check: "",
            T_Currency: res[i].currname,
            creditcode: res[i].creditcode,
            currencycode: res[i].currencycode,
            exchangerate: res[i].exchangerate,
            taxtype: res[i].taxtype,
          }
        }
        setopenBackdrop(false)
        setTimeout(() => {
          console.log(openBackdrop);
        }, 500);
        setproducts([...data])
        //  setproducts(products => [...products,{currentOrNewKey: data}])
      } else {
        setopenBackdrop(false)
      }
    }).catch(error => {
      // this._chkload("Error" + error);
      console.log(error);
      setopenBackdrop(false)
    });
  }
  const Get_PopUpSel = (data) => {
    console.log(data);
    let select = OtPopupType;
    if (select === "SaleMan") {
      SaleMan.current.value = data;
    }
    if (select === "Groupdata") {
      Groupdata.current.value = data;
    }
    setSelectPopup(!SelectPopup)
  }

  function PopUp_CloseSublist() {
    sethidden(false)
    setCloseSublist(!CloseSublist)
  }
  function PopUp_CsHistory() {
    setCSHistory(!CSHistory)

  }
  function PopUp_EmpHistory() {
    setEMPHistory(!EMPHistory)

  }
  function onRowDoubleClick(row, col, id,) {
    if (row.T_Queue !== undefined) {
      setDoubledata(row)
      sethidden(true)

      setCloseSublist(!CloseSublist)
    }
  }
  function onRowClick(row, col, id,) {
    if (row.T_Queue !== undefined) {
      setSUCCESS("SUCCESS")
    } else {
      setSUCCESS(null)
    }
  }
  function CsHistory() {
    if (SUCCESS === "SUCCESS") {
      setCSHistory(!CSHistory)

    }
  }
  function EmpHistory() {
    if (SUCCESS === "SUCCESS") {
      setEMPHistory(!EmpHistory)
    }
  }
  const Getdata = () => {
    setCloseSublist(!CloseSublist)
    sethidden(false)
    onSearch()
  }

  return (
    <div className="PSApp"
    // onBlur={onBlur}
    >
      <Backdrop open={openBackdrop} />
      {CSHistory ? <PopUpCsHistory closePopup={PopUp_CsHistory} /* Get_PopUpCsHistory={Get_PopUpCsHistory} */ from="CSPR" /> : null}
      {EMPHistory ? <PopUpEmpHistory closePopup={PopUp_EmpHistory} /* Get_PopUpEmpHistory={Get_PopUpEmpHistory} */ from="CSPR" /> : null}
      {CloseSublist ? <PopUpCloseSublist closePopup={PopUp_CloseSublist} Getdata={Getdata} data={Doubledata} from="PopUpSelSaleRef3" /> : null}
      {SelectPopup ? <PopUpSelect closePopup={Switch_Select} Get_PopUpSel={Get_PopUpSel} type={OtPopupType} from="CSPR" /> : null}
      <nav className="navbar TopApp">
        <div className="flex-list">
          <ul className="nav navbar-nav navbar-left">
            <li><span onClick={onSearch}><i className="fas fa-search"></i>  แสดงข้อมูล </span></li><span className="pipe"></span>
            <li><span onClick={onRemove}><i className="far fa-trash-alt"></i> ล้างข้อมูล </span></li><span className="pipe"></span>
            <li><span onClick={CsHistory}> <i className="far fa-address-book"></i> ประวัติลูกค้า </span></li><span className="pipe"></span>
            <li><span onClick={EmpHistory} className=" btn-md" ><i className="far fa-address-card"></i> ประวัติพนักงาน</span></li><span className="pipe"></span>
            <li><span><i className="fas fa-file-alt"></i> ไปยังเอกสาร </span></li><span className="pipe"></span>
          </ul>
          <ul className="nav navbar-nav navbar-right" style={{ marginRight: '0px' }}>
            <li> ปิดใบสั่งขาย </li>
          </ul>
        </div>
      </nav>
      <div className="gropbox">
        <div className="row">
          <div className="miniicon">ปิดใบสั่งขาย</div>
          <div className="miniicon1 .col-4" >
            <DropdownButton bsSize="xs" id="dropdown-size-extra-small" pullRight title={<i className="fas fa-align-justify"></i>} noCaret bsStyle="default">
              <MenuItem onClick={onSearch}><span><i className="fas fa-search"></i> แสดงข้อมูล </span></MenuItem>
              <MenuItem onClick={onRemove}><span><i className="far fa-trash-alt"></i> ล้างข้อมูล </span></MenuItem>
              <MenuItem onClick={CsHistory}><span><i className="far fa-address-book"></i> ประวัติลูกค้า </span></MenuItem>
              <MenuItem onClick={EmpHistory}><span><i className="far fa-address-card"></i> ประวัติพนักงาน</span></MenuItem>
              <MenuItem ><span><i className="fas fa-file-alt"></i> ไปยังเอกสาร </span></MenuItem>
            </DropdownButton>
          </div>
        </div>
      </div>

      <div className="PSAppfrom">
        <Grid>
          <Col xs={12} sm={12} md={12} lg={12}>
            <Row className="show-grid">
              <Col xs={12} sm={4} md={4} lg={4}>
                <Row className="show-grid">
                  {/* <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                      <span className="input-group-addon">วันที่ขอสั่งซื้อ</span>
                      <input type="text" className="form-control" ref={BuyDate} name="BuyDate" />
                      <span className="input-group-addon icon"><SelectFix type="Calendar" SelectSetData={SelectSetData} /></span>
                    </div>
                  </div> */}
                  <MaterialUIPickers title="จากวันที่เอกสาร"
                    DateValue={e => SelectSetData("Calendar", e)}
                    defaultdate={BuyDate} />
                </Row>
              </Col>
              <Col xs={12} sm={4} md={4} lg={4}>
                <Row className="show-grid">
                  {/* <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                      <span className="input-group-addon">ถึงวันที่เอกสาร</span>
                      <input type="text" className="form-control" ref={Calendar1} name="Calendar1" />
                      <span className="input-group-addon icon"><SelectFix type="Calendar1" SelectSetData={SelectSetData} /></span>
                    </div>
                  </div> */}
                  <MaterialUIPickers title="ถึงวันที่เอกสาร"
                    DateValue={e => SelectSetData("Calendar1", e)}
                    defaultdate={Calendar1} />
                </Row>
              </Col>
              <Col xs={12} sm={4} md={4} lg={4}>
                <Row className="show-grid">
                  <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                      <span className="input-group-addon">เลือกพนักงาน</span>
                      <input type="text" className="form-control hidden" ref={SaleMan_code} />
                      <input type="text" className="form-control" name="SaleMan" ref={SaleMan} disabled />
                      <span className="input-group-addon icon" onClick={Switch_Select.bind(null, "SaleMan")}>{
                        <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                      }</span>
                    </div>
                  </div>
                </Row>
              </Col>
              <Col xs={12} sm={4} md={4} lg={4}>
                <Row className="show-grid">
                  <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                      <span className="input-group-addon">รหัส/ซื่อลูกค้า</span>
                      <input type="text" className="form-control" ref={DeliNumber} />
                    </div>
                  </div>
                </Row>
              </Col>
              <Col xs={12} sm={4} md={4} lg={4}>
                <Row className="show-grid">
                  <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                      <span className="input-group-addon">เลือกกลุ่มเอกสาร</span>
                      <input type="text" className="form-control" name="Groupdata" ref={Groupdata} disabled />
                      <span className="input-group-addon icon" onClick={Switch_Select.bind(null, "Groupdata")}>{
                        <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                      }</span>
                    </div>
                  </div>
                </Row>
              </Col>
            </Row>
          </Col>
        </Grid>
      </div>

      <div className="container-fluid PSAppTable table-responsive" hidden={hidden}>
        <BootstrapTable
          data={products}
          tableHeaderclassName='AppHeaderTable'
          trClassName='trClassName'
          options={{ noDataText: "...", onRowDoubleClick: onRowDoubleClick, onRowClick: onRowClick }}
          height='400'
          hover
          selectRow={{ mode: 'radio', clickToSelect: true }}
        >
          <TableHeaderColumn dataField='C0' isKey width="50" dataAlign="center" ></TableHeaderColumn>
          <TableHeaderColumn dataField='T_Date' editable={true} dataAlign="left" width='100' > <div align="center"> วันที่ </div> </TableHeaderColumn>
          <TableHeaderColumn dataField='T_Queue' editable={false} dataAlign="left" width='170' > <div align="center"> ใบจอง </div> </TableHeaderColumn>
          <TableHeaderColumn dataField='T_Code' editable={false} dataAlign="left" width='150' > <div align="center"> รหัสลูกค้า </div> </TableHeaderColumn>
          <TableHeaderColumn dataField='T_Name' editable={false} dataAlign="left" width='150' > <div align="center"> ชื่อลูกค้า </div> </TableHeaderColumn>
          <TableHeaderColumn dataField='T_Remark' editable={false} dataAlign="left" width='150' ><div align="center"> หมายเหตุ </div></TableHeaderColumn>
          <TableHeaderColumn dataField='T_SaleMan' editable={false} dataAlign="left" width='150' > พนักงาน </TableHeaderColumn>
          <TableHeaderColumn dataField='T_Promise' editable={false} dataAlign="left" width='150' > <div align="center"> นัดส่งมอบ </div></TableHeaderColumn>
          <TableHeaderColumn dataField='T_Amount' editable={false} dataAlign="right" width='150' > <div align="center"> จำนวนเงิน </div></TableHeaderColumn>
          <TableHeaderColumn dataField='T_Debtor' editable={false} dataAlign="right" width='150' > <div align="center"> ยอดลูกหนี้ </div></TableHeaderColumn>
          <TableHeaderColumn dataField='T_Cheque' editable={false} dataAlign="left" width='150' > <div align="center"> เช็คในมือ </div></TableHeaderColumn>
          <TableHeaderColumn dataField='T_Check' editable={false} dataAlign="left" width='150' > <div align="center"> เช็คคืน </div></TableHeaderColumn>
          <TableHeaderColumn dataField='T_Currency' editable={false} dataAlign="left" width='150' > <div align="center"> สกุลเงิน </div></TableHeaderColumn>
        </BootstrapTable>
      </div>
      <Snackbar place="br"
        color={color}
        icon={icon}
        autoClose={autoClose}
        message={messagealert}
        open={opensnackbar}
        closeNotification={() => { setopensnackbar(false) }}
        close />
    </div >
  )
}
